var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card page-max" },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "ruleForm",
              staticClass: "demo-ruleForm",
              attrs: { model: _vm.ruleForm, "label-width": "180px" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "商品品牌" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        clearable: "",
                        placeholder: "请选择",
                        filterable: "",
                        "filter-method": _vm.handleAgreementSearch,
                      },
                      model: {
                        value: _vm.ruleForm.brandId,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "brandId", $$v)
                        },
                        expression: "ruleForm.brandId",
                      },
                    },
                    _vm._l(_vm.brandOption, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.brandStr, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "门店名称：",
                    prop: "storeName",
                    rules: [
                      {
                        required: true,
                        message: "请填写",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请填写" },
                    model: {
                      value: _vm.ruleForm.storeName,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "storeName", $$v)
                      },
                      expression: "ruleForm.storeName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "门店电话：",
                    prop: "storePhone",
                    rules: [
                      {
                        required: true,
                        message: "请填写",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请填写" },
                    model: {
                      value: _vm.ruleForm.storePhone,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "storePhone", $$v)
                      },
                      expression: "ruleForm.storePhone",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "选择地区：",
                    prop: "areaList",
                    rules: [
                      {
                        required: true,
                        message: "请选择",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c("el-cascader", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      clearable: "",
                      options: _vm.addresData,
                      props: {
                        value: "id",
                        label: "name",
                        children: "child",
                        checkStrictly: true,
                      },
                    },
                    model: {
                      value: _vm.ruleForm.areaList,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "areaList", $$v)
                      },
                      expression: "ruleForm.areaList",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "门店经度：",
                    prop: "storeLng",
                    rules: [
                      {
                        required: true,
                        message: "请填写",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c("el-input-number", {
                    attrs: { controls: false, placeholder: "请填写" },
                    model: {
                      value: _vm.ruleForm.storeLng,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "storeLng", $$v)
                      },
                      expression: "ruleForm.storeLng",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "门店维度：",
                    prop: "storeLat",
                    rules: [
                      {
                        required: true,
                        message: "请填写",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c("el-input-number", {
                    attrs: { controls: false, placeholder: "请填写" },
                    model: {
                      value: _vm.ruleForm.storeLat,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "storeLat", $$v)
                      },
                      expression: "ruleForm.storeLat",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "门店地址：",
                    prop: "storeAddr",
                    rules: [
                      {
                        required: true,
                        message: "请填写",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请填写" },
                    model: {
                      value: _vm.ruleForm.storeAddr,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "storeAddr", $$v)
                      },
                      expression: "ruleForm.storeAddr",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "门店形象：" } }, [
                _c(
                  "div",
                  { staticStyle: { display: "flex", "align-items": "center" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "upLoadPicBox",
                        on: {
                          click: function ($event) {
                            return _vm.modalPicTap("1")
                          },
                        },
                      },
                      [
                        _vm.ruleForm.storePic
                          ? _c("div", { staticClass: "pictrue" }, [
                              _c("img", {
                                attrs: { src: _vm.ruleForm.storePic },
                              }),
                            ])
                          : _c("div", { staticClass: "upLoad" }, [
                              _c("i", {
                                staticClass: "el-icon-camera cameraIconfont",
                              }),
                            ]),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.ruleForm.storePic
                      ? _c("i", {
                          staticClass: "el-icon-delete",
                          staticStyle: { color: "red", "font-size": "16px" },
                          on: {
                            click: function ($event) {
                              return _vm.removeImg("image")
                            },
                          },
                        })
                      : _vm._e(),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("el-form-item", [
                _c(
                  "div",
                  { staticStyle: { "text-align": "center" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", loading: _vm.loading },
                        on: {
                          click: function ($event) {
                            return _vm.handerSubmit("ruleForm")
                          },
                        },
                      },
                      [_vm._v("确认提交")]
                    ),
                    _vm._v(" "),
                    _c("el-button", { on: { click: _vm.goReturn } }, [
                      _vm._v("返回列表"),
                    ]),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }